import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MLayoutService } from './layout.service';
import { IMenu } from './layout.type';
@Component({
  selector: 'm-layout-sider',
  template: `
    <div class="m-layout-sider-logo">
      <img [src]="mLogo" />
    </div>
    <ul class="m-layout-sider-ul">
      <ng-container *ngFor="let item of _menus">
        <li *ngIf="item.children && item.children.length; else subMenu" (click)="onMenuClick(item)" [ngClass]="{ selected: item.open }">
          <i nz-icon [nzType]="item.icon" *ngIf="item.icon"></i>
          <span>{{ item.title }}</span>
        </li>
        <ng-template #subMenu>
          <li [routerLink]="item.link" (click)="onMenuClick(item)" [ngClass]="{ selected: item.open }">
            <i nz-icon [nzType]="item.icon" *ngIf="item.icon"></i>
            <span>{{ item.title }}</span>
          </li>
        </ng-template>
      </ng-container>
    </ul>
    <div class="m-layout-sider-extra">
      <i nz-icon nzType="setting" nzTheme="outline"></i>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
  exportAs: 'mLayoutSider',
  host: {
    class: 'm-layout-sider'
  }
})
export class MLayoutSiderComponent {
  @Input() mLogo = '';
  @Input()
  set menus(menus: IMenu[]) {
    this._menus = menus;
    this.resume();
    this.openCurrentMenu();
  }
  get menus(): IMenu[] {
    return this._menus;
  }
  @Output() readonly sideMenuClick = new EventEmitter<IMenu>();

  _menus: IMenu[] = [];
  subscription = new Subscription();
  constructor(private layoutService: MLayoutService, private router: Router) {
    this.subscription.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
        this.openCurrentMenu();
      })
    );
  }

  onMenuClick(menu: IMenu): void {
    menu.open = !menu.open;
    this.onOpenChange(menu.open, menu);
    this.layoutService.sideMenuClick$.next(menu.children ?? []);
    this.sideMenuClick.emit(menu);
  }

  openCurrentMenu(): void {
    const filterVisible = (menu: IMenu[]) => menu.filter(item => !(item.visible === false));
    const menus = filterVisible(this.menus.slice());
    const dealData = (dealMenus: IMenu[]): boolean | void => {
      for (const menu of dealMenus) {
        if (menu.children && menu.children.length > 0) {
          menu.children = filterVisible(menu.children);
          if (dealData(menu.children)) {
            menu.open = true;
            this.layoutService.sideMenuClick$.next(menu.children);
            return true;
          } else {
            menu.open = false;
          }
        }
        if (menu.link && this.router.isActive(menu.link, !!menu.matchRouterExact)) {
          return true;
        }
      }
    };
    dealData(menus);
    this._menus = menus;
  }

  resume(): void {
    let i = 1;
    const setId = (menus: IMenu[]) => {
      for (const item of menus) {
        item._id = i++;
        if (item.children && item.children.length > 0) {
          setId(item.children);
        }
      }
    };
    setId(this._menus);
  }

  onOpenChange(open: boolean, curMenu: IMenu): void {
    const menus = this.menus.slice();
    const dealData = (dealMenus: IMenu[]): boolean | void => {
      for (const menu of dealMenus) {
        if (menu._id === curMenu._id) {
          dealMenus
            .filter(item => item._id !== curMenu._id)
            .forEach(m => {
              m.open = false;
            });
          return true;
        }
        if (menu.children && menu.children.length > 0) {
          if (dealData(menu.children)) {
            return true;
          }
        }
      }
    };
    if (open) {
      dealData(menus);
      this._menus = menus;
    }
  }
}
